import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { AppSecurityService } from "../services";

// Generic per-feature route guard. Attach with route data, e.g.
//   { path: 'roles', component: RoleHomeComponent, canActivate: [FeatureGuard], data: { feature: 'role-admin' } }
// A route serving two audiences can pass `anyFeature: ['a', 'b']` instead - holding ANY of them
// admits (e.g. Payroll Requests: submitters OR approvers). A route with no `feature`/`anyFeature`
// in data is allowed (acts as a no-op). Denied users go to /access-denied.
export const FeatureGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

    const router: Router = inject(Router);
    const appSecurityService: AppSecurityService = inject(AppSecurityService);
    const required = route.data?.['feature'] as string | undefined;
    const anyOf = route.data?.['anyFeature'] as string[] | undefined;

    return appSecurityService.ensureFeaturesLoaded().pipe(
        map(() => {
            const allowed = anyOf?.length
                ? anyOf.some(f => appSecurityService.hasFeature(f))
                : (!required || appSecurityService.hasFeature(required));
            return allowed
                ? true
                : router.createUrlTree(['/access-denied'], { queryParams: { returnUrl: state.url } });
        })
    );
}
